import Http from '../base-http'


class UserPosition extends Http {
  
}

const userPosition = new UserPosition({
  modelUrlPrefix : 'userPosition'
})

export default userPosition
